import { createSelector } from 'reselect'

import confirmTypes from 'helpers/enums/confirmTypes'
import userLoggedSelector from 'redux/selectors/user_extra_data/user_logged_selector'
import userFullNameSelector from 'redux/selectors/user/user_full_name_selector'

const getStudentViewData = state => state.student
const getSlideId = (_, props) => props.session.session_uid + '_' + props.slide.slideId
const getConfirmsData = state => state.confirm

const getLeadInitialValues = (slideData, defaultName, isUserLogged) => {
	const initialValues = {
		name: defaultName,
		optionalName: '',
	}

	if (slideData) {
		if (slideData.lastSubmittedName && !isUserLogged) {
			initialValues.name = String(slideData.lastSubmittedName)
			initialValues.optionalName = String(slideData.lastSubmittedOptionalName)
		} else if (slideData.appDataLeadName && !isUserLogged) {
			initialValues.name = String(slideData.appDataLeadName)
		} else if (slideData.lastNicknameUserLoggedSigned) {
			initialValues.name = String(slideData.lastNicknameUserLoggedSigned)
		} else if (slideData.complementaryLeadData && slideData.complementaryLeadData.firstField) {
			initialValues.name = String(slideData.complementaryLeadData.firstField)
			initialValues.optionalName = String(slideData.complementaryLeadData.secondField)
		}
	}

	return initialValues
}

const getConfirm = function(confirms) {
	const confirmsArray = [
		confirmTypes.STUDENT_LEAD_MESSAGE,
	]
	if (confirms && confirms.length && confirmsArray.includes(confirms[0].confirmType)) {
		return confirms[0]
	} else {
		return null
	}
}

const leadSlideSelector = createSelector(
	[userLoggedSelector, userFullNameSelector, getStudentViewData, getSlideId, getConfirmsData],
	(isUserLogged, userFullName, student, slideId, confirms) => {
		const slide_data = student.slides[slideId]
		const initialValues = getLeadInitialValues(slide_data, userFullName, isUserLogged)
		const confirm = getConfirm(confirms)
		let isSubmitting = false
		let isValid = true
		let shouldDisableWelcomeInputs = false
		if (slide_data) {
			isSubmitting = slide_data.isSubmitting
			isValid = slide_data.isValid
			shouldDisableWelcomeInputs = !!(student.isFromLTI && slide_data.appDataLeadName)
		}

		return {
			slide_data,
			initialValues,
			confirm,
			isSubmitting,
			isValid,
			shouldBlockAutofillLead: !!student.isFromLTI,
			shouldDisableWelcomeInputs,
		}
	}
)

export default leadSlideSelector
